import MagnifiedImageFrame from "@/components/magnifyImageFrame";
import { COLLAB_CONSTANTS } from "./constants";

const CollabComp = () => {
  return <MagnifiedImageFrame {...COLLAB_CONSTANTS} />;
};

export default CollabComp;
